import { useState } from "react";
import { Smartphone, X } from "lucide-react";
import { LocateCaller } from "@/components/LocateCaller";

// Dispatch Board row action: issue a Text-to-Locate link without opening the call.
export const BoardLocateButton = ({ incident }) => {
  const [open, setOpen] = useState(false);
  const loc = incident.caller_location;
  return (
    <span className="relative inline-block" onClick={(e) => e.stopPropagation()}>
      <button type="button" data-testid={`board-locate-${incident.cc_number}`} onClick={() => setOpen((v) => !v)}
        title={loc ? `Caller GPS ${loc.lat.toFixed(5)}, ${loc.lng.toFixed(5)} — click to re-locate` : "Send the caller a Text-to-Locate link"}
        className={`ml-1.5 inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm text-[9px] font-head font-bold border ${loc ? "border-[#10B981]/60 text-[#6EE7B7] bg-[#10B981]/10" : "border-[#DC2626]/70 text-[#FCA5A5] hover:bg-[#DC2626]/20"}`}>
        <Smartphone size={10} /> {loc ? "GPS ✓" : "LOCATE"}
      </button>
      {open && (
        <div data-testid={`board-locate-pop-${incident.cc_number}`} className="absolute left-0 top-full mt-1 z-[60] w-[380px] bg-[#0F1012] border border-[#DC2626]/60 shadow-2xl p-2 rounded-sm text-left">
          <div className="flex items-center justify-between font-mono text-[9px] uppercase tracking-wider text-[#FCA5A5] mb-1">
            <span>Locate caller · {incident.public_ref ? `CAD# ${incident.public_ref}` : incident.cc_number}{incident.caller?.phone ? ` · ${incident.caller.phone}` : " · no caller phone on call"}</span>
            <button type="button" onClick={() => setOpen(false)}><X size={11} /></button>
          </div>
          <LocateCaller incident={incident} compact />
          <button type="button" data-testid={`board-locate-open-${incident.cc_number}`} onClick={() => { window.location.href = `/incident/${incident.id}`; }} className="mt-1.5 font-mono text-[9px] text-[#93C5FD] underline">Open full call (photos, chat, landmark tools) →</button>
        </div>
      )}
    </span>
  );
};
